import { BookOpen, Heart } from "@phosphor-icons/react";

export const Footer = () => (
  <footer className="mt-24 border-t-2 border-slate-900/5 bg-white">
    <div className="max-w-7xl mx-auto px-6 py-12 grid gap-8 sm:grid-cols-3">
      <div>
        <div className="flex items-center gap-2.5 mb-3">
          <span className="grid place-items-center w-10 h-10 rounded-2xl bg-white ring-1 ring-slate-900/5 overflow-hidden">
            <img
              src="https://static.prod-images.emergentagent.com/jobs/289f5bfb-a361-4a61-8407-48b3421a1ec8/images/c4cf84e1360572fb8c7750cbf1af0a64fd151ace8ea145fab45add9f505baa69.jpeg"
              alt="Reading Keeper bookshelf logo"
              className="w-full h-full object-cover"
            />
          </span>
          <span className="font-heading font-bold text-lg text-ink">Reading Keeper</span>
        </div>
        <p className="font-body text-ink-soft leading-relaxed text-sm max-w-xs">
          Joyful, level-by-level reading packages that help little learners grow from first sounds to full stories.
        </p>
      </div>
      <div>
        <p className="font-heading font-semibold text-ink mb-3">Reading Levels</p>
        <ul className="font-body text-sm text-ink-soft space-y-2">
          <li>Pre-K Phonics</li><li>Kindergarten Sight Words</li>
          <li>Pre-K &amp; Kindergarten</li><li>Grades 1–3</li>
          <li>Grades 4 &amp; 5</li><li>1-on-1 Tutoring</li>
        </ul>
      </div>
      <div>
        <p className="font-heading font-semibold text-ink mb-3">For Families</p>
        <p className="font-body text-sm text-ink-soft leading-relaxed">
          Every package is a one-time purchase you can access online, anytime, forever.
        </p>
      </div>
    </div>
    <div className="border-t border-slate-900/5 py-5 text-center font-body text-sm text-ink-soft">
      Made with <Heart size={14} weight="fill" className="inline text-brand-coral" /> for curious little readers.
    </div>
  </footer>
);
